import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { QuestionServiceService } from '../../../../../services/question-service.service';
import { FeeColumnFilterPanelService } from '../../../../../services/fee-column-filter-panel.service';
import { a } from '@angular/core/src/render3';
import { forkJoin, Subscription } from '../../../../../store';
import { ClubMemberService } from '../../../../../services';
import * as moment from 'moment';

@Component({
  selector: 'app-tryout-set-questions',
  templateUrl: './tryout-set-questions.component.html',
  styleUrls: ['./tryout-set-questions.component.css']
})
export class TryoutSetQuestionsComponent implements OnInit {
  @Input() changing: Subject<number>;
  @Input() TryoutMemberID: number;
  @Input() TryoutMemberstatus: string;
  @Output() getMemberEvent = new EventEmitter();
  @Output() closeSideOverlayEvent = new EventEmitter();
  @Output() getMembersbyStatusData = new EventEmitter();

  public setQuestions: FormGroup;
  public QuesstionList = [];
  public Answers = [];
  public Option = [];
  public currentUrl = '';
  public routeParams;
  public validationMessages = {};
  public Answer: string;
  public AnswerID: number;
  public QuestionID: number;
  public AnswersData = [];
  sub: Subscription;


  constructor(private activeRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private spinnerService: Ng4LoadingSpinnerService,
    private notificationsService: NotificationsService,
    private questionService: QuestionServiceService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private memberService: ClubMemberService
  ) {
    this.validationMessages = {
      'FirstName': 'First Name is required.',
      'LastName': 'Last Name is required.',
      'Gender': 'Gender is required.',
      'PlayerEmail': 'Player Email is required.',
      'PlayerPhone': 'Player Phone is required.',
      'Address': 'Address is required.',
      'City': 'City is required.',
      'State': 'State is required.',
      'PostalCode': 'Postal Code is required.',
      'Citizenship': 'Citizenship is required.',
      'ParentGuardian': 'Parent/Guardian is required.',
      'CellPhone': 'Cell Phone is required.',
      'ParentEmail': 'Parent Email is required.',

    };
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    this.clearValidation();
    // this.initSetQuestionForm();
    this.getQuestions('0');
    this.changing.subscribe(memberId => {
      //console.log(' value is changing ', memberId);
      this.TryoutMemberID = memberId;
      this.getQuestions('0');
    });
  }

  initSetQuestionForm() {
    const groups = {
      ParentUserID: [null, [Validators.required]],
      ParentFirstName: [null, [Validators.required]],
      ParentLastName: [null, [Validators.required]],
      ParentEmail: [null, [Validators.email, Validators.required]],
      ParentPhone: [null]
    };
    if (!!this.QuesstionList && !!this.QuesstionList.length) {
      const len = this.QuesstionList.length;
      for (let i = 0; i < len; i++) {
        const item = this.QuesstionList[i];
        if (!item) { continue; }
        let value = item.answer;
        if (item.queOptionList && item.queOptionList.length) {
          value = item.clubprogramanswerID;
          const anw = item.queOptionList.find(o => o.isSelected);
          if (anw) {
            value = anw.clubProgramQuestionOptionID;
          }
        }
        groups[item.label] = [value, item.isrequired ? [Validators.required] : []];
      }
    }
    this.setQuestions = this.fb.group(groups);
  }

  getQuestions(status) {
    this.spinnerService.show();
    const UserID = this.TryoutMemberID.toString();
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.questionService.getSetQuestions(this.routeParams.id, status, UserID).subscribe(rs => {
      this.QuesstionList = rs.standardQuestionAnswerList;
      this.initSetQuestionForm();
      for (let i = 0; i < this.QuesstionList.length; i++) {
        this.AnswerID = this.QuesstionList[i].clubprogramanswerID;
        this.QuestionID = this.QuesstionList[i].clubprogramquestionID;
      }

      if (rs.parent) {
        this.setQuestions.patchValue({
          ParentUserID: rs.parent.userID,
          ParentFirstName: rs.parent.firstName,
          ParentLastName: rs.parent.lastName,
          ParentEmail: rs.parent.email,
          ParentPhone: rs.parent.phone
        });
      }
    });
  }

  clearValidation() {
    for (let i = 0; i < this.QuesstionList.length; i++) {
      if (this.QuesstionList[i].questionTypeID != 1) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID != 2) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID != 3) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID != 4) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID != 5) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      }
    }
  }

  removeValidaionCodeDiscount(name) {
    const control = this.setQuestions.get(name);
    control.clearValidators();
    control.updateValueAndValidity();
  }

  validateUi() {
    Object.keys(this.setQuestions.controls).forEach(field => {
      const control = this.setQuestions.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  OncheckBoxSelected(Id, Des) {
    const OpionData = {
      clubProgramAnswerID: Number(Id),
      description: Des.toString()
    };
    this.Option.push(OpionData);
  }

  isInvalid(c: string): boolean {
    const control = this.setQuestions.get(c);
    return control.touched && !!control.errors;
  }

  get playerAge(): number {
    const q = this.QuesstionList.find(q => q.label.toLowerCase().indexOf('date of birth') > -1);
    if (q) {
      const dob = this.setQuestions.get(q.label).value;
      return moment().diff(moment(dob), 'years');
    }
    return 0;
  }

  onSave(event, status) {
    event.stopPropagation();
    this.validateUi();
    const data = this.QuesstionList.map(q => {
      const selectedOption = q.queOptionList && q.queOptionList.length
        && q.queOptionList.find(x => x.clubProgramQuestionOptionID === +this.setQuestions.controls[q.label].value);
      const answer = selectedOption ? selectedOption.optionDescription : this.setQuestions.controls[q.label].value;

      return {
        UserID: +this.TryoutMemberID,
        Answer: answer,
        Question: q.label,
        ClubProgramAnswerID: q.clubprogramanswerID || 0,
        ClubProgramQuestionID: q.clubprogramquestionID,
        AnswerOptionList: []
      };
    });

    if (status === 'VALID') {
      this.spinnerService.show();
      const OBJ = {
        answers: data
      };

      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      const formData = this.setQuestions.value;
      forkJoin(
        this.questionService.updateAnswer(OBJ),
        this.memberService.updateUser({
          UserID: formData.ParentUserID,
          FirstName: formData.ParentFirstName,
          LastName: formData.ParentLastName,
          Email: formData.ParentEmail,
          Phone: formData.ParentPhone
        })
      ).subscribe(rs => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        console.log('result', rs);
        this.alertMessage('success', rs);
        this.closeSideOverlayEvent.emit();
        this.getMembersbyStatusData.emit();
        this.spinnerService.hide();
      }, error => {
        this.alertMessage('error', error.statusText);
        this.spinnerService.hide();
      });
    }
  }
  onCancle(event) {
    this.clearFormData();
    this.closeSideOverlayEvent.emit();
    this.setQuestions.reset();
    this.setQuestions.clearValidators();
    this.setQuestions.updateValueAndValidity();
  }

  clearFormData() {
    this.setQuestions.reset();
  }

  isValidIsMultiChoice(required, name) {
    if (required === 1) {
      return this.setQuestions.get(name).errors
        && (this.setQuestions.get(name).touched
          || this.setQuestions.get(name).dirty);
    }
  }

  isValidSingleChoice(required, name) {
    if (required === 1) {
      return this.setQuestions.get(name).errors
        && (this.setQuestions.get(name).touched
          || this.setQuestions.get(name).dirty);
    }
  }

  isValidDropDown(required, name) {
    if (required === 1) {
      return this.setQuestions.get(name).errors
        && (this.setQuestions.get(name).touched
          || this.setQuestions.get(name).dirty);
    }
  }

  isValidIsSingleLine(required, name) {
    if (required === 1) {
      return this.setQuestions.get(name).errors
        && (this.setQuestions.get(name).touched
          || this.setQuestions.get(name).dirty);
    }
  }

  isValidLongText(required, name) {
    if (required === 1) {
      return this.setQuestions.get(name).errors
        && (this.setQuestions.get(name).touched
          || this.setQuestions.get(name).dirty);
    }
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.html(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-members/partial/tryout-set-questions/tryout-set-questions.component.ts